import styles from "./Badge.module.scss";
import cn from "classnames";
import React from "react";
import Icon from "@components/new/Icon";
import { BadgeType } from "./types.ts";

interface BadgeProps {
  children?: React.ReactNode;
  type?: BadgeType;
  onClick?: () => void;
  asChild?: boolean;
  rounded?: boolean;
  iconLeft?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  iconRight?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  className?: string;
}

export const Badge = ({
  className,
  type: bType_,
  children,
  onClick,
  asChild,
  rounded,
  iconLeft,
  iconRight,
}: BadgeProps) => {
  const bType = bType_ || BadgeType.PRIMARY;
  const badgeClassName = cn(
    styles.badge,
    onClick && styles.clickable,
    styles[`type-${bType}`],
    rounded && styles.rounded,
  );

  if (asChild && React.Children.count(children) === 1) {
    return React.Children.map(children, (child: React.ReactNode) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          // @ts-ignore
          className: cn(child.props.className, badgeClassName),
        });
      }
    });
  };

  return (
    <div
      onClick={onClick}
      className={cn(badgeClassName, className)}
    >
      {iconLeft ? (<Icon className={styles.icon} icon={iconLeft} />) : null}

      {children}

      {iconRight ? (<Icon className={styles.icon} icon={iconRight} />) : null}
    </div>
  );
};
